<template>
    <div>
        <div v-if="isPrintView">
            <PrintLabel />
        </div>
        <div v-else>
            <div v-if="loading" :class="{'absolute z-20 h-screen bg-trasperent top-0 left-0' : loading}" class="w-full py-8 px-4 flex flex-col justify-center items-center">
                <svg class="animate-spin -ml-1 mr-3 h-12 w-12 text-blue-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <div class="text-gray-600 text-lg mt-2 text-center">Logging in please wait...</div>
            </div>
            <div v-else>
                <DashboardLayoutComponent v-if="userAuth && userData && userData.id" />
                <AuthBaseLayout v-if="!userAuth" />
            </div>
            <!-- loader to show when file is getting downloaded or previewed  -->
            <div class="flex fixed top-3 w-66 py-3 px-6 rounded right-16 z-50" v-if="isAttachmentLoading">
                <div class="mb-2 rounded px-4 py-3 bg-gray-600">
                    <div class="flex items-center space-x-2 justify-center">
                        <p class="text-sm text-white">Loading</p>
                        <p>
                            <svg class="mr-3 -ml-1 w-4 h-4 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </p>
                    </div>
                </div>
            </div>    
            <AlertComponent v-if="showErrorObj" />
            <Menu>
                <MenuButton id="headlessui-menu-button-3" type="button" aria-expanded="true" aria-haspopup="true"
                    class="absolute top-3 mr-4 px-2 py-2 text-neutral-600 shadow-sm hover:shadow-md hover:bg-neutral-50 bg-white z-10" :class="sidebarVisible ? 'right-96' : 'right-48'">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 7V5.2C18 4.0799 18 3.51984 17.782 3.09202C17.5903 2.71569 17.2843 2.40973 16.908 2.21799C16.4802 2 15.9201 2 14.8 2H9.2C8.0799 2 7.51984 2 7.09202 2.21799C6.71569 2.40973 6.40973 2.71569 6.21799 3.09202C6 3.51984 6 4.0799 6 5.2V7M6 18C5.07003 18 4.60504 18 4.22354 17.8978C3.18827 17.6204 2.37962 16.8117 2.10222 15.7765C2 15.395 2 14.93 2 14V11.8C2 10.1198 2 9.27976 2.32698 8.63803C2.6146 8.07354 3.07354 7.6146 3.63803 7.32698C4.27976 7 5.11984 7 6.8 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V14C22 14.93 22 15.395 21.8978 15.7765C21.6204 16.8117 20.8117 17.6204 19.7765 17.8978C19.395 18 18.93 18 18 18M15 10.5H18M9.2 22H14.8C15.9201 22 16.4802 22 16.908 21.782C17.2843 21.5903 17.5903 21.2843 17.782 20.908C18 20.4802 18 19.9201 18 18.8V17.2C18 16.0799 18 15.5198 17.782 15.092C17.5903 14.7157 17.2843 14.4097 16.908 14.218C16.4802 14 15.9201 14 14.8 14H9.2C8.0799 14 7.51984 14 7.09202 14.218C6.71569 14.4097 6.40973 14.7157 6.21799 15.092C6 15.5198 6 16.0799 6 17.2V18.8C6 19.9201 6 20.4802 6.21799 20.908C6.40973 21.2843 6.71569 21.5903 7.09202 21.782C7.51984 22 8.07989 22 9.2 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </MenuButton>
                <MenuItems
                    class="absolute origin-top-right z-20 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 top-14 focus:outline-none" :class="sidebarVisible ? 'right-96' : 'right-48'" >
                    <MenuItem v-if="!isPoDetailPage">
                        <button @click="printVisiblePage" class="p-3 text-sm text-neutral-800">Print Main Content</button>
                    </MenuItem>
                    <MenuItem>
                        <button @click="printSidebar" class="p-3 text-sm text-neutral-800">Print Sidebar</button>
                    </MenuItem>
                </MenuItems>
            </Menu>
        </div> 
    </div>
</template>

<script>
import commonMixin from './mixin';
import DashboardLayoutComponent from './views/layout/DashboardLayoutComponent.vue'
import AuthBaseLayout from './views/layout/auth/BaseLayout.vue'
import AlertComponent from '@/components/AlertComponent.vue'
import PrintLabel from './views/PrintLabelView.vue'
import html2pdf from 'html2pdf.js';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
export default {
    name: 'App',
    mixins: [commonMixin],
    components: {
        DashboardLayoutComponent,
        AuthBaseLayout,
        AlertComponent,
        PrintLabel,  Menu, MenuButton, MenuItems, MenuItem
    },
    data() {
        return {
            loading: false,
            sidebarVisible: false,
            isPoDetailPage: false,
        }
    },
    watch: {
        $route(to) {
            this.isPoDetailPage = to.name === 'purchase_order_detail';
        }
    },
    mounted() {
        this.$router.isReady()
            .then(() => {
                if (
                    'setToken' in this.$route.query && 
                    this.$route.query.setToken
                ) {
                    this.loading = true;
                    const switchUser = 'switch_user' in this.$route.query && this.$route.query.switch_user == '1';
                    this.$store.dispatch('fetchUserData', {token: this.$route.query.setToken, storeToken: true, switchUser})
                        .then(res => {
                            if (res) {
                                this.$router.replace({name: 'dashboard'})
                                this.loading = false;
                            } else {
                                this.$router.replace({name: 'login'});
                                this.loading = false;
                            }
                        })
                        .catch(() => {
                            this.$router.replace({name: 'login'});
                            this.loading = false;
                        })
                } else if (this.userAuth) {
                    this.$store.dispatch('checkAuth');
                    this.isPoDetailPage = this.$route.name == 'purchase_order_detail'
                }
        }).catch(() => {
            console.log('router not ready')
        })
        this.checkSidebar();
        const observer = new MutationObserver(() => {
            this.checkSidebar();
        });
        observer.observe(document.body, { childList: true, subtree: true });
    },
    methods: {
        checkSidebar() {
            this.sidebarVisible = !!document.querySelector('#detailsSlideOver');
        },
        printSidebar() {
            const original = document.querySelector('#detailsSlideOver');
            if (!original) {
                alert('Sidebar element not found!');
                return;
            }

            // Clone the element
            const clone = original.cloneNode(true);
            clone.id = 'printableSidebar'; // avoid duplicate IDs
            clone.style.position = 'static';
            clone.style.transform = 'none';
            clone.style.display = 'block';
            clone.style.visibility = 'visible';
            clone.style.opacity = '1';
            clone.classList.remove('fixed', 'transform', 'translate-x-0', 'hidden', 'sm:hidden');

            // Optional: remove tailwind utility classes that hide it
            clone.classList.add('block'); // override `hidden` or responsive hidden classes

            // Append clone to body
            document.body.appendChild(clone);

            // Generate PDF
            const options = {
                margin: 10,
                filename: 'sidebar.pdf',
                image: { type: 'jpeg', quality: 1.0 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    logging: true,
                    windowWidth: clone.scrollWidth,
                    windowHeight: clone.scrollHeight,
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'a3',
                    orientation: 'portrait',
                }
            };

            html2pdf().set(options).from(clone).save().then(() => {
                // Clean up
                document.body.removeChild(clone);
            });
            },

        printVisiblePage() {
            const element = document.querySelector('#printable-area main');

            // STEP 1: Save original link styles and apply temporary print styles
            const styledLinks = [];
            element.querySelectorAll('a').forEach(a => {
                styledLinks.push({
                    el: a,
                    originalBg: a.style.backgroundColor
                });
                a.style.backgroundColor = 'transparent';
            });
            const styledDivs = [];
            element.querySelectorAll('div').forEach(div => {
                styledDivs.push({
                    el: div,
                    originalBg: div.style.backgroundColor
                });
                div.style.backgroundColor = 'transparent';
            });

            // STEP 2: Replace input elements with static span versions
            const inputReplacements = [];
            element.querySelectorAll('input').forEach(input => {
                const replacement = document.createElement('div');
                replacement.textContent = input.value;
                replacement.style.cssText = `
                    padding: 8px;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                    font-size: 14px;
                    background-color: #f9f9f9;
                    min-height: 38px;
                `;
                replacement.classList.add('input-replacement');
                input.style.display = 'none';
                input.parentNode.insertBefore(replacement, input);
                inputReplacements.push({ input, replacement });
            });

            // STEP 3: Generate PDF
            const options = {
                margin: [10, 2, 10, 2],
                filename: 'Main Content.pdf',
                image: { type: 'jpeg', quality: 1.0 },
                html2canvas: {
                    scale: 1.5,
                    useCORS: true,
                    logging: true,
                    ignoreElements: el => el.classList?.contains('pdf-hidden'),
                    windowWidth: element.scrollWidth,
                    windowHeight: element.scrollHeight,
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'a2',
                    orientation: 'portrait',
                }
            };

            html2pdf().set(options).from(element).save().then(() => {
                // STEP 4: Restore original input fields
                inputReplacements.forEach(({ input, replacement }) => {
                    replacement.remove();
                    input.style.display = '';
                });

                // STEP 5: Restore original link styles
                styledLinks.forEach(({ el, originalColor, originalBg }) => {
                    el.style.backgroundColor = originalBg;
                });
                styledDivs.forEach(({ div, originalColor, originalBg }) => {
                    div.style.backgroundColor = originalBg;
                });
            });
        }
    },
    computed: {
        isAttachmentLoading() {
            return this.$store.getters['general/isAttachmentLoading'];
        },
        isPrintView() {
            return this.$route.name == 'print_label'
        },
        showErrorObj() {
            const errorObj = this.$store.getters.errorObj;
            return errorObj.title || errorObj.body; 
        },
    }
}
</script>

<style>
@media print {
    a, a * {
        color: #000 !important; /* or your desired text color */
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
        background-color: #ffffff !important;
    }
}
</style>
